export const DURATIONS = {
  DEFAULT: 3000,
  SHORT: 2000,
  LONG: 5000,
};
